import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { botapi } from "../../Appjs/api.js";


export const rcsBotsApi = createApi({
  reducerPath: "rcsBotsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: botapi,
  }),
    tagTypes: ["RcsBots"],
    endpoints:(builder)=>({
        getRcsBotsList: builder.query({
            query: () => ({
                url: `/api/v1/get-all-brands`,
                method: `GET`,
            headers: {
          "apikey": "f0cdbd4a-038c-422c-9f79-c5f2608177df",
        },
            }),
            providesTags: ['RcsBots'],
        }),
        
    }),
});

export const { useGetRcsBotsListQuery,  } = rcsBotsApi;
